/** Progressive enhancement for homepage pagination. Collection pages use Horizon's native renderer. */
(() => {
  let loading = false;
  document.addEventListener('click', async (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('[data-nioso-home-pagination] .pagination a');
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
    const region = link.closest('[data-nioso-home-pagination]');
    const wrapper = region?.closest('.shopify-section');
    if (!wrapper) return;
    const destination = new URL(link.href, location.href);
    if (destination.origin !== location.origin || destination.pathname !== location.pathname) return;
    event.preventDefault();
    if (loading) return;
    // Keep preview_theme_id and any existing storefront context when Shopify supplies a relative page link.
    const pageURL = new URL(location.href);
    for (const [key, value] of destination.searchParams) pageURL.searchParams.set(key, value);
    pageURL.searchParams.delete('section_id');
    pageURL.hash = wrapper.id;
    const requestURL = new URL(pageURL);
    requestURL.hash = '';
    requestURL.searchParams.set('section_id', region.dataset.niosoHomePagination);
    loading = true;
    region.setAttribute('aria-busy', 'true');
    let timeout;
    const controller = new AbortController();
    try {
      timeout = setTimeout(() => controller.abort(), 15000);
      const response = await fetch(requestURL, { signal: controller.signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error('Pagination unavailable');
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = parsed.getElementById(wrapper.id);
      if (!next?.querySelector('[data-nioso-home-pagination]')) throw new Error('Incomplete section');
      wrapper.replaceWith(document.importNode(next, true));
      history.pushState({ niosoPagination: true }, '', pageURL);
      const fresh = document.getElementById(next.id);
      fresh?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      const current = fresh?.querySelector('[aria-current="page"]');
      if (current) {
        current.setAttribute('tabindex', '-1');
        current.focus({ preventScroll: true });
      }
    } catch {
      // Ordinary Shopify page navigation remains the fallback when AJAX is unavailable.
      location.assign(pageURL.href);
    } finally {
      clearTimeout(timeout);
      region.removeAttribute('aria-busy');
      loading = false;
    }
  });
  // Restore server-rendered products when visitors use browser Back / Forward.
  window.addEventListener('popstate', () => {
    if (document.querySelector('[data-nioso-home-pagination]')) location.reload();
  });
})();
